import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import SEO, { SITE_URL } from '../../components/feature/SEO';

const collections = [
  {
    id: 'bullion',
    title: 'Bullion Emblem',
    titleKo: '불리온 엠블럼',
    description:
      '금 및 은 도금 불리온 와이어를 사용해 입체적으로 제작하는 최고급 엠블럼. 군사 예복, 고급 유니폼, 기업 배지 등 품격 있는 자리에 완벽한 마감을 선사합니다.',
    specs: ['순금/순은 와이어 사용', '3D 입체 제작', '맞춤 사이즈 가능', '금도금·은도금 옵션'],
    icon: 'ri-medal-2-line',
    bg: '#1A1A1A',
  },
  {
    id: 'handmade',
    title: 'Handmade Embroidery',
    titleKo: '핸드메이드 자수',
    description:
      '장인이 한 땀 한 땀 손으로 완성하는 핸드메이드 자수. 실크, 금사, 은사 등 소재로 섬세한 문양을 완성합니다. 의상, 액세서리, 홈 데코 등 다양하게 활용됩니다.',
    specs: ['실크·금사·은사 소재', '자유로운 패턴 디자인', '의상·소품 등 다용도', '세탁 가능 마감'],
    icon: 'ri-scissors-cut-line',
    bg: '#2C2C2C',
  },
  {
    id: 'patch',
    title: 'Embroidery Frame',
    titleKo: '자수 패치',
    description:
      '브랜드 로고, 문장, 캐릭터 등을 정교하게 자수를 놓아 액자로 제작합니다. 기념일, 행사에&nbsp;',
    specs: ['로고·문장·캐릭터 재현', '다양한 원단 베이스', '열접착·봉제 부착', '대량 생산 가능'],
    icon: 'ri-layout-masonry-line',
    bg: '#1A1A1A',
  },
  {
    id: 'custom',
    title: 'Custom Premium',
    titleKo: '프리미엄 맞춤',
    description:
      '고객의 아이디어를 예술 작품으로 구현하는 완전 맞춤 제작 서비스. 디자인 컨설팅부터 샘플, 최종 납품까지 원스톱으로 진행합니다.',
    specs: ['1:1 디자인 컨설팅', '샘플 제작 후 확인', '전 공정 핸드메이드', '납기 준수 보장'],
    icon: 'ri-pencil-ruler-2-line',
    bg: '#252525',
  },
];

const processSteps = [
  { step: '01', title: '상담 및 디자인', desc: '고객 요구사항 청취 및 디자인 방향 설정' },
  { step: '02', title: '시안 제작', desc: '디지털 시안 및 샘플 자수 제작' },
  { step: '03', title: '소재 선정', desc: '용도에 맞는 최적 소재 및 색상 선정' },
  { step: '04', title: '장인 제작', desc: '숙련된 장인에 의한 핸드메이드 제작' },
  { step: '05', title: '품질 검수', desc: '엄격한 다단계 품질 검수 진행' },
  { step: '06', title: '납품', desc: '안전 포장 및 신속 납품' },
];

const embroideryJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '자수 컬렉션 | HivanTex Embroidery Collection',
    url: `${SITE_URL}/embroidery`,
    description: '불리온 엠블럼, 핸드메이드 자수, 자수 패치, 프리미엄 맞춤 제작 컬렉션을 소개합니다.',
    inLanguage: 'ko',
    provider: {
      '@type': 'Organization',
      name: '하이반텍스 HivanTex',
      url: SITE_URL,
    },
    hasPart: [
      {
        '@type': 'Service',
        name: 'Bullion Emblem',
        description: '금 및 은 도금 불리온 와이어를 사용해 입체적으로 제작하는 최고급 엠블럼',
        provider: { '@type': 'Organization', name: '하이반텍스 HivanTex' },
      },
      {
        '@type': 'Service',
        name: 'Handmade Embroidery',
        description: '장인이 한 땀 한 땀 손으로 완성하는 핸드메이드 자수',
        provider: { '@type': 'Organization', name: '하이반텍스 HivanTex' },
      },
      {
        '@type': 'Service',
        name: 'Embroidery Frame',
        description: '브랜드 로고, 문장, 캐릭터 등을 정교하게 자수를 놓아 액자로 제작',
        provider: { '@type': 'Organization', name: '하이반텍스 HivanTex' },
      },
      {
        '@type': 'Service',
        name: 'Custom Premium',
        description: '고객의 아이디어를 예술 작품으로 구현하는 완전 맞춤 제작 서비스',
        provider: { '@type': 'Organization', name: '하이반텍스 HivanTex' },
      },
    ],
  },
];

export default function EmbroideryPage() {
  return (
    <div className="min-h-screen font-sans bg-cream">
      <SEO jsonLd={embroideryJsonLd} />
      <Navbar />

      {/* Hero */}
      <section className="relative bg-[#181818] pt-40 pb-28 px-16 overflow-hidden">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage:
              'radial-gradient(ellipse 50% 60% at 70% 50%, rgba(201,169,97,0.07) 0%, transparent 65%)',
          }}
        />
        <div className="absolute top-28 left-14 w-12 h-12 border-l border-t border-gold/25" />
        <div className="absolute bottom-12 right-14 w-12 h-12 border-r border-b border-gold/25" />
        <div className="max-w-[1300px] mx-auto relative z-10">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-8 h-px bg-gold/50" />
            <span className="text-gold text-[10px] tracking-[0.3em] uppercase font-sans">Collection</span>
          </div>
          <h1 className="font-serif text-cream text-6xl font-light leading-tight tracking-wide mb-6">
            자수 컬렉션<br />
            <em className="not-italic text-gold">Embroidery</em>
          </h1>
          <p className="text-cream/40 text-sm font-sans font-light leading-8 max-w-xl">
            불리온 엠블럼부터 핸드메이드 자수까지, 하이반텍스의 모든 컬렉션을 만나보세요.
          </p>
        </div>
      </section>

      {/* Collections */}
      <section className="py-28 px-16">
        <div className="max-w-[1300px] mx-auto space-y-6">
          {collections.map((col, i) => (
            <div
              key={col.id}
              className="group grid grid-cols-2 overflow-hidden"
              style={{ backgroundColor: col.bg }}
            >
              <div className={`p-14 ${i % 2 !== 0 ? 'order-2' : ''}`}>
                <div className="w-10 h-10 flex items-center justify-center border border-gold/30 mb-8">
                  <i className={`${col.icon} text-gold text-base`} />
                </div>
                <h2 className="font-serif text-cream text-3xl font-light mb-2 tracking-wide">
                  {col.title}
                </h2>
                <p className="text-gold text-[10px] tracking-[0.2em] uppercase font-sans mb-6">
                  {col.titleKo}
                </p>
                <p className="text-cream/45 text-sm leading-8 font-sans font-light mb-8">
                  {col.description}
                </p>
                <ul className="space-y-2 mb-10">
                  {col.specs.map((s) => (
                    <li key={s} className="flex items-center gap-3 text-cream/35 text-xs font-sans">
                      <span className="w-1 h-1 rounded-full bg-gold/60 shrink-0" />
                      {s}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-3 border border-gold/40 text-gold text-[10px] tracking-[0.2em] uppercase px-8 py-3 hover:bg-gold hover:text-charcoal transition-all duration-300 font-sans whitespace-nowrap cursor-pointer"
                >
                  문의하기
                  <i className="ri-arrow-right-line text-xs" />
                </Link>
              </div>
              <div className={`flex items-center justify-center p-14 ${i % 2 !== 0 ? 'order-1' : ''}`}
                style={{ backgroundColor: `${col.bg}cc` }}>
                <div className="border border-gold/15 w-full aspect-square flex flex-col items-center justify-center p-12">
                  <div className="w-8 h-px bg-gold/30 mb-8" />
                  <i className={`${col.icon} text-gold/30 mb-6`} style={{ fontSize: '4rem' }} />
                  <p className="font-serif text-gold/50 text-2xl font-light tracking-widest text-center">
                    {col.title}
                  </p>
                  <div className="w-8 h-px bg-gold/30 mt-8" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Process */}
      <section className="bg-[#1C1C1C] py-28 px-16">
        <div className="max-w-[1300px] mx-auto">
          <div className="text-center mb-16">
            <p className="text-gold text-[10px] tracking-[0.3em] uppercase font-sans mb-4">How We Work</p>
            <h2 className="font-serif text-cream text-4xl font-light tracking-wide">제작 과정</h2>
          </div>
          <div className="grid grid-cols-3 gap-6">
            {processSteps.map((s) => (
              <div key={s.step} className="border border-cream/5 p-8 hover:border-gold/25 transition-colors duration-300">
                <span className="font-serif text-gold/30 text-4xl font-light block mb-5">{s.step}</span>
                <h3 className="text-cream text-sm font-sans font-medium tracking-wide mb-3">{s.title}</h3>
                <p className="text-cream/35 text-xs font-sans font-light leading-6">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-16 bg-cream text-center">
        <p className="text-gold text-[10px] tracking-[0.3em] uppercase font-sans mb-5">Start Your Project</p>
        <h3 className="font-serif text-charcoal text-4xl font-light mb-8 tracking-wide">
          맞춤 제작을 시작해보세요
        </h3>
        <Link
          to="/contact"
          className="inline-flex items-center gap-3 bg-charcoal text-cream text-[10px] tracking-[0.2em] uppercase px-12 py-4 hover:bg-gold hover:text-charcoal transition-all duration-300 font-sans whitespace-nowrap cursor-pointer"
        >
          상담 신청하기
          <i className="ri-arrow-right-line text-xs" />
        </Link>
      </section>

      <Footer />
    </div>
  );
}
